import { ShieldAlert } from 'lucide-react'

import { cn } from '@/lib/utils'

type Props = { className?: string }

export function AuthCaptchaNotice({ className }: Props) {
  return (
    <div
      className={cn(
        'rounded-xl border border-blue-300/80 bg-blue-50 px-4 py-3 text-sm text-blue-950 dark:border-blue-500/30 dark:bg-blue-500/10 dark:text-blue-100',
        className,
      )}
      role="status"
    >
      <div className="flex gap-3">
        <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-blue-600 dark:text-blue-400" aria-hidden />
        <div className="space-y-1">
          <p className="font-semibold">Güvenlik doğrulaması gerekli</p>
          <p className="leading-relaxed opacity-90">
            Çok fazla başarısız giriş denemesi tespit edildi. Devam etmek için &quot;Ben robot
            değilim&quot; kutusunu işaretleyin.
          </p>
        </div>
      </div>
    </div>
  )
}
